import React from 'react';
import styles from './XMainForm.module.scss';

export interface IMainFormProps {
    class?: string | null;
    children? : React.ReactNode;
}

export interface IMainFormState {
}

export class XMainForm extends React.Component<IMainFormProps, IMainFormState> {

    public constructor(props: IMainFormProps) {
        super(props)
    }

    render() : React.ReactNode {
        return (
            <div className={styles.XMainForm}>{this.props.children}</div>
        );
    }

}
